export default "__VITE_ASSET__884dce64__"